import _ from 'lodash';
import React from 'react';
import copy from 'copy-to-clipboard';
import { Avatar } from '@mui/material';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { createNotification } from 'react-redux-notify';
import { Dropdown, Image, Row, Col } from 'react-bootstrap';

import Location from '../common/Location';
import UrlUtils from '../../helpers/utils/url';
import { getUserId } from '../../helpers/storage/user';
import { getBaseUrl } from '../../helpers/constants/resource';
import { ChatroomStatusEnum } from '../../helpers/constants/message';
import { getSuccessNotificationMessage } from '../helper/NotificationMessage';

const defaultProfile = 'https://d9apl513jlx0u.cloudfront.net/public_assets/src/images/default/profile_placeholder.jpg';

export const ChatWindowHeaderDesktop = ({
  member,
  blockChatroom,
  getUserStatus,
  setShowReport,
  isSidebarClass,
  unblockChatroom,
  setChatroomVisible,
  setChatroomInvisible,
  muteChatroomNotification,
  unmuteChatroomNotification,
  setShowDeleteConverstaionConfirmation,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chatroom = useSelector((state) => state.chat.activeConversation?.chatroom);

  const isActive = () => {
    return chatroom?.status === ChatroomStatusEnum.Active;
  };

  const isBlocked = () => {
    return chatroom?.status === ChatroomStatusEnum.Blocked;
  };

  const isDeleted = () => {
    return chatroom?.deleted_at;
  };

  const isVisible = () => {
    return chatroom?.settings && chatroom?.settings[getUserId()]
      ? chatroom?.settings[getUserId()].visible
      : true;
  };

  const isNotificationsOn = () => {
    return chatroom?.settings && chatroom?.settings[getUserId()]
      ? chatroom?.settings[getUserId()].notification
      : true;
  };

  const redirectToProfile = () => {
    if (!member?.deleted_at) {
      navigate(`/user/${encodeURIComponent(member?.username?.toLowerCase())}`);
    }
  };

  const onCopyProfileLinkClicked = () => {
    if (!member?.deleted_at) {
      copy(UrlUtils.normalize(`${getBaseUrl()}/user/${encodeURIComponent(member?.username?.toLowerCase())}`));
      dispatch(createNotification(getSuccessNotificationMessage('Profile Url Copied!')));
    }
  };

  return (
    <div className={`headchat ${isSidebarClass.first}`}>
      <Row>
        <Col md={5}>
          <ul className='activechat' onClick={() => redirectToProfile()}>
            <li>
              <div className='imgchat'>
                <Avatar src={member?.picture} style={{ width: '50px', height: '50px' }} alt='avtar'>
                  <Image src={defaultProfile} round alt='profile' />
                </Avatar>
              </div>
              <div className='textchat'>
                <p> {`${member?.username}`} </p>
                <Location city={member?.city} country={member?.country} />
                <span>{getUserStatus(chatroom)}</span>
              </div>
            </li>
          </ul>
        </Col>
        <Col md={7} className='messagesendbtn'>
          <Dropdown className='arrowremove'>
            <Dropdown.Toggle variant='link' id='dropdown-basic'>
              <Image
                src={                  
                  'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/' +
                  (localStorage.getItem('isDark') === 'true' ? 'sidedottedwhite' : 'sidedotted') +
                  '.svg'
                }
                alt='side dotted icon'
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item className='bt' onClick={() => redirectToProfile()}>
                @{member?.username}
                {(member?.city || member?.country) && (
                  <Location city={member?.city} country={member?.country} />
                )}
              </Dropdown.Item>
              {!member?.deleted_at && (
                <Dropdown.Item onClick={() => onCopyProfileLinkClicked()}>
                  Copy link to Profile
                </Dropdown.Item>
              )}

              {isVisible() ? (
                <Dropdown.Item onClick={() => setChatroomInvisible(chatroom?.id)}>
                  Hide chat
                </Dropdown.Item>
              ) : (
                <Dropdown.Item onClick={() => setChatroomVisible(chatroom?.id)}>
                  Show chat
                </Dropdown.Item>
              )}
              {isNotificationsOn() ? (
                <Dropdown.Item
                  className='bt'
                  onClick={() => muteChatroomNotification(chatroom?.id)}
                >
                  Mute Notifications @{member?.username}
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  className='bt'
                  onClick={() => unmuteChatroomNotification(chatroom?.id)}
                >
                  Unmute Notifications @{member?.username}
                </Dropdown.Item>
              )}
              {isActive() && (
                <Dropdown.Item onClick={() => blockChatroom(chatroom?.id)}>
                  Block @{member?.username}
                </Dropdown.Item>
              )}
              {(isBlocked() && chatroom?.blocked_by === getUserId()) && (
                <Dropdown.Item onClick={() => unblockChatroom(chatroom?.id)}>
                  Unblock @{member?.username}
                </Dropdown.Item>
              )}
              {!member?.deleted_at && (
                <Dropdown.Item href='#' onClick={() => setShowReport(true)}>
                  Report @{member?.username}
                </Dropdown.Item>
              )}
              {!isDeleted() && (
                <Dropdown.Item onClick={() => setShowDeleteConverstaionConfirmation(true)}>
                  Delete converstaion
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <hr />
    </div>
  );
};

export const ChatWindowHeaderMobile = ({
  member,
  setShowReport,
  blockChatroom,
  getUserStatus,
  unblockChatroom,
  handleSidebarClass,
  setChatroomVisible,
  setChatroomInvisible,
  muteChatroomNotification,
  unmuteChatroomNotification,
  setShowDeleteConverstaionConfirmation
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const chatroom = useSelector((state) => state.chat.activeConversation?.chatroom);

  const isActive = () => {
    return chatroom?.status === ChatroomStatusEnum.Active;
  };

  const isBlocked = () => {
    return chatroom?.status === ChatroomStatusEnum.Blocked;
  };

  const isDeleted = () => {
    return chatroom?.deleted_at;
  };

  const isVisible = () => {
    return chatroom?.settings && chatroom?.settings[getUserId()]
      ? chatroom?.settings[getUserId()].visible
      : true;
  };

  const isNotificationsOn = () => {
    return chatroom?.settings && chatroom?.settings[getUserId()]
      ? chatroom?.settings[getUserId()].notification
      : true;
  };

  const redirectToProfile = () => {
    if (!member?.deleted_at) {
      navigate(`/user/${encodeURIComponent(member?.username?.toLowerCase())}`);
    }
  };

  const onCopyProfileLinkClicked = () => {
    if (!member?.deleted_at) {
      copy(UrlUtils.normalize(`${getBaseUrl()}/user/${encodeURIComponent(member?.username?.toLowerCase())}`));
      dispatch(createNotification(getSuccessNotificationMessage('Profile Url Copied!')));
    }
  };

  return (
    <div className='res-header hideback'>
      <div className='d-flex justify-content-between h-100 align-items-center'>
        <button className='btn' onClick={() => handleSidebarClass()} title='back'>
          <Image
            src={`https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/${
              localStorage.getItem('isDark') === 'true' ? 'dark_back' : 'backBtn'
            }.svg`}
            alt='back button icon'
          />
        </button>
        <div className='userchatmessage active'>
          <span>{member?.username}</span>
          <span>{getUserStatus(chatroom)}</span>
        </div>
        <div className='activemessagechat mr-2'>
          <Dropdown className='arrowremove'>
            <Dropdown.Toggle variant='link' id='dropdown-basic'>
              <Image
                src={
                  'https://d9apl513jlx0u.cloudfront.net/public_assets/public/assets/images/icons/' +
                  (localStorage.getItem('isDark') === 'true' ? 'sidedottedwhite' : 'sidedotted') +
                  '.svg'
                }
                alt='side dotted icon'
              />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item href='#' onClick={() => redirectToProfile()}>
                @{member?.username}
                {(member?.city || member?.country) && (
                  <Location city={member?.city} country={member?.country} />
                )}
              </Dropdown.Item>
              {!member?.deleted_at && (
                <Dropdown.Item href='#' onClick={() => onCopyProfileLinkClicked()}>
                  Copy link to Profile
                </Dropdown.Item>
              )}
              {isVisible() ? (
                <Dropdown.Item onClick={() => setChatroomInvisible(chatroom?.id)}>
                  Hide chat
                </Dropdown.Item>
              ) : (
                <Dropdown.Item onClick={() => setChatroomVisible(chatroom?.id)}>
                  Show chat
                </Dropdown.Item>
              )}
              {isNotificationsOn() ? (
                <Dropdown.Item
                  href='#'
                  className='bt'
                  onClick={() => muteChatroomNotification(chatroom?.id)}
                >
                  Mute Notifications @{member?.username}
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  href='#'
                  className='bt'
                  onClick={() => unmuteChatroomNotification(chatroom?.id)}
                >
                  Unmute Notifications @{member?.username}
                </Dropdown.Item>
              )}
               {isActive() && (
                <Dropdown.Item onClick={() => blockChatroom(chatroom?.id)}>
                  Block @{member?.username}
                </Dropdown.Item>
              )}
              {(isBlocked() && chatroom?.blocked_by === getUserId()) && (
                <Dropdown.Item onClick={() => unblockChatroom(chatroom?.id)}>
                  Unblock @{member?.username}
                </Dropdown.Item>
              )}
              {!member?.deleted_at && (
                <Dropdown.Item href='#' onClick={() => setShowReport(true)}>
                  Report @{member?.username}
                </Dropdown.Item>
              )}
              {!isDeleted() && (
                <Dropdown.Item onClick={() => setShowDeleteConverstaionConfirmation(true)}>
                  Delete converstaion
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};
